<template>
  <div class="container">
    <div class="exclamation">
      <ExclamationIcon class="icon" />
    </div>

    <h1 class="page-title">There’s a problem</h1>

    <p>
      This page could not be found.
    </p>

    <router-link class="btn btn--big" to="/">Back Home</router-link>
  </div>
</template>

<script>
import ExclamationIcon from "@/assets/svg/icon-exclamation.svg";

export default {
  name: "NotFound",
  components: {
    ExclamationIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
}

.exclamation {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: #e1011b;
  width: 100px;
  height: 100px;
  margin: 0 auto $spacing-large auto;

  .icon {
    fill: white;
    height: 60px;
  }
}
</style>
